import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import RegistrationBenefits from './RegistrationBenefits';

import t from '../../lib/I18n';
import config from '../../config';

const BrandUsps = ({steps, currentStep, dictionaryPrefix}) => {
    const stepName = _.findKey(steps, step => step === currentStep);

    const brand = config.get('brand');
    const headingMessage = t(`${dictionaryPrefix}${stepName.toLowerCase()}.title`);
    const headingClass = classnames('content-wrapper__usps__heading text-weight--bold', {
        'text-left': currentStep === 2,
        'content-wrapper__usps__heading--tp': brand === 'transpennine'
    });

    return (
        <React.Fragment>
            <FormattedHTMLMessage
                message={headingMessage}
                tagName="h1"
                className={headingClass}
            />
            {currentStep === 1 && (
                <img
                    src={config.get('registerDetailsImageUrl')}
                    alt={t('account.register.details.alt', {
                        brand: config.get('brand')
                    })}
                    className="content-wrapper__usps__details-image"
                />
            )}
            <p className={classnames('content-wrapper__usps__body-text', {'content-wrapper__usps__body-text--create': currentStep === 1})}>
                {t(`${dictionaryPrefix}${stepName.toLowerCase()}.body`)}
            </p>
            {currentStep === 1 && (
                <RegistrationBenefits benefits={config.get('createAccountBenefits')} />
            )}
            {currentStep === 2 && (
                <React.Fragment>
                    <RegistrationBenefits benefits={config.get('smartcardRegistrationBenefits')} />
                    <img
                        src={config.get('registerSmartcardImageUrl')}
                        alt={t('account.register.smartcard.alt')}
                        className="content-wrapper__usps__smartcard-image"
                    />
                </React.Fragment>
            )}
            {currentStep === 3 && (
                <img
                    src={config.get('registerPreferencesImageUrl')}
                    alt={t('account.register.preferences.alt', {
                        brand: config.get('brand')
                    })}
                    className="content-wrapper__usps__preferences-image"
                />
            )}
        </React.Fragment>
    );
};

BrandUsps.propTypes = {
    steps: PropTypes.object,
    currentStep: PropTypes.number,
    dictionaryPrefix: PropTypes.string,
};

BrandUsps.defaultProps = {
    steps: {},
    currentStep: 0,
    dictionaryPrefix: '',
};

export default BrandUsps;



// WEBPACK FOOTER //
// ./src/components/login/BrandUsps.js